import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["modal", "image", "counter", "prevButton", "nextButton"]

  connect() {
    this.element.dataset.imageGalleryReady = ""
    this.handleKeydown = this.handleKeydown.bind(this)
  }

  open(event) {
    event.preventDefault()
    const button = event.target.closest("[data-gallery-urls]")
    if (!button) return

    this.images = JSON.parse(button.dataset.galleryUrls)
    this.currentIndex = parseInt(button.dataset.galleryIndex, 10) || 0

    this.updateImage()
    this.modalTarget.classList.remove("hidden")
    document.addEventListener("keydown", this.handleKeydown)
  }

  close() {
    this.modalTarget.classList.add("hidden")
    document.removeEventListener("keydown", this.handleKeydown)
  }

  next() {
    if (this.currentIndex < this.images.length - 1) {
      this.currentIndex++
      this.updateImage()
    }
  }

  previous() {
    if (this.currentIndex > 0) {
      this.currentIndex--
      this.updateImage()
    }
  }

  closeOnBackdrop(event) {
    if (event.target === this.modalTarget) {
      this.close()
    }
  }

  handleKeydown(event) {
    if (event.key === "ArrowLeft") this.previous()
    if (event.key === "ArrowRight") this.next()
    if (event.key === "Escape") this.close()
  }

  updateImage() {
    this.imageTarget.src = this.images[this.currentIndex]
    const multi = this.images.length > 1

    this.prevButtonTarget.classList.toggle("hidden", !multi || this.currentIndex === 0)
    this.nextButtonTarget.classList.toggle("hidden", !multi || this.currentIndex === this.images.length - 1)

    if (multi) {
      this.counterTarget.textContent = `${this.currentIndex + 1} / ${this.images.length}`
      this.counterTarget.classList.remove("hidden")
    } else {
      this.counterTarget.classList.add("hidden")
    }
  }
}
